import { HttpClient } from '@angular/common/http';

import type { HttpResourceRequest } from '@angular/common/http';
import { Service, inject } from '@angular/core';
import { environment } from '@env/environment';
import type { PagedListRequest } from '@shared/api/common/dtos/requests/paged-list.request';
import type { CreateUserRequest } from '@shared/api/identity/dtos/requests/create-user.request';
import type { TransferAccountOwnershipRequest } from '@shared/api/identity/dtos/requests/transfer-account-ownership.request';
import type { UpdateUserRequest } from '@shared/api/identity/dtos/requests/update-user.request';
import { UserLookupFilterEnum } from '@shared/api/identity/enums/user-lookup-filter.enum';
import { withAuth } from '@shared/utils/http-context.util';
import type { Observable } from 'rxjs';

@Service()
export class UserClient {
  private http = inject(HttpClient);

  public buildUserLookupRequest(filter: UserLookupFilterEnum = UserLookupFilterEnum.SomenteAtivos): HttpResourceRequest {
    return {
      url: `${environment.urlApiPlatform}user/lookup`,
      method: 'GET',
      params: { filter },
      ...withAuth(),
    };
  }

  public buildPaginatedRequest(request: PagedListRequest): HttpResourceRequest {
    return {
      url: `${environment.urlApiPlatform}user/paged`,
      method: 'POST',
      body: request,
      ...withAuth(),
    };
  }

  public buildUserRequest(idUser: number): HttpResourceRequest {
    return {
      url: `${environment.urlApiPlatform}user/byId/${idUser}`,
      method: 'GET',
      ...withAuth(),
    };
  }

  public create(request: CreateUserRequest): Observable<void> {
    return this.http.post<void>(`${environment.urlApiPlatform}User/create`, request, withAuth());
  }

  public update(request: UpdateUserRequest, idUser: number): Observable<void> {
    return this.http.put<void>(`${environment.urlApiPlatform}user/${idUser}`, request, withAuth());
  }

  public delete(idUser: number): Observable<void> {
    return this.http.delete<void>(`${environment.urlApiPlatform}user/${idUser}`, withAuth());
  }

  public sendPasswordLink(idUser: number): Observable<void> {
    return this.http.post<void>(`${environment.urlApiPlatform}user/${idUser}/password-link`, null, withAuth());
  }

  public transferOwnership(request: TransferAccountOwnershipRequest): Observable<void> {
    return this.http.post<void>(`${environment.urlApiPlatform}user/transfer-ownership`, request, withAuth());
  }
}
